import moment from 'moment/moment';
import React from 'react';
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogTitle,
  DialogFooter,
  Button,
  Grid,
  Cell,
} from '../../../components/BillingMDC';
import BillingTextField from '../../../components/TextField/BillingTextField';
import BillingSelect from '../../../components/Select/BillingSelect';

const DialogView = ({
  ledgerList,
  onModalClose,
  modalOpen,
  editModalOpen,
  deleteModalOpen,
  createDN,
  handleInputChange,
  onModalSubmit,
  formEmptyField,
  tagList,
  addTag,
  renderLedgerSelectOptions,
}) =>{
  return (
    <Dialog
      open={modalOpen || editModalOpen || deleteModalOpen}
      onClose={() => {
        onModalClose();
      }}
    >
      <DialogHeader>
        {modalOpen && <DialogTitle>Create Debit Note</DialogTitle>}
        {editModalOpen && <DialogTitle>Edit Debit Note</DialogTitle>}
        {deleteModalOpen && <DialogTitle>Delete Debit Note</DialogTitle>}
      </DialogHeader>
      {!deleteModalOpen && (
        <DialogBody>
          <div className='dialog-upperpart'>
            <Grid className='grid-padding'>
            {renderLedgerSelectOptions()}

              <Cell col={6} tablet={6}>
                <BillingTextField
                  value={createDN.cr_amount}
                  handleChange={handleInputChange}
                  floatingLabel='Amount'
                  param='cr_amount'
                  type='number'
                  required
                  zeroError={false}
                  className='billing-required right-side-gap'
                  emptyField={formEmptyField}
                />
              </Cell>
            </Grid>
            <Grid className='grid-padding'>
              <Cell col={6} tablet={8}>
                <label className='select-custom-label'>Tag</label>
                <BillingSelect
                  name='form-field-name'
                  param='tagid'
                  clearable
                  value={createDN.tagid}
                  valueKey='idTags'
                  labelKey='title'
                  options={tagList}
                  floatingLabel='Tag'
                  handleChange={handleInputChange}
                  multipleParam
                  emptyField={addTag && formEmptyField}
                  required={addTag && true}
                />
              </Cell>
            </Grid>
            <Grid className='grid-padding'>
              <Cell col={12} tablet={12}>
                <BillingTextField
                  value={createDN.narration}
                  param='narration'
                  floatingLabel='Narration'
                  className='textbox billing-required'
                  handleChange={handleInputChange}
                />
              </Cell>
            </Grid>
          </div>
        </DialogBody>
      )}

      {deleteModalOpen && (
        <div className='default-margin-24'>Are you sure you want to delete ?</div>
      )}

      <DialogFooter>
        <Button
          accent
          className='dialog-cancel modal-btn'
          onClick={() => {
            onModalClose();
          }}
        >
        Cancel
        </Button>
        <Button
          accent
          className='dialog-ok modal-btn'
          onClick={() => {
            onModalSubmit();
          }}
        >
        Ok
        </Button>
      </DialogFooter>
    </Dialog>
  )};

export default DialogView;
